import { T }   from 'defa-object';
/**
 * poppet.CollectionView
 * An extended Marionette CollectionView.
 * @version 1.1.0
 */
import Snippet from 'scripts/poppet/snippet';

const CollectionView = Mn.CollectionView.extend( {

	/**
	 * Triggers when a childView requests to open.
	 * @param {string} event  The nav event.
	 * @param {array} params  Array of params to iterpret the nav event.
	 * @void
	 */
	onChildviewNav: function ( event, params ) {
		this.trigger( 'nav', event, params );
	},
	
	/**
	 * Triggers when a childView requests to open.
	 * @param {view} childView  The view the event originated from.
	 * @void
	 */
	onChildviewOpen: function ( childView ) {
		this.trigger( 'open', childView );
	},
	
	/**
	 * Triggers when a childView requests settings.
	 * @param {view} childView  The view the event originated from.
	 * @void
	 */
	onChildviewSettings: function ( childView ) {
		this.trigger( 'settings', childView );
	},
	
	/**
	 * Triggers when a childView requests to delete.
	 * @param {view} childView  The view the event originated from.
	 * @void
	 */
	onChildviewDelete: function ( childView ) {
		this.trigger( 'delete', childView );
	},
	
	/**
	 * Triggers when a childView is selected.
	 * @param {view} childView  The view the event originated from.
	 * @void
	 */
	onChildviewSelected: function ( childView ) {
		this.trigger( 'selected', childView );
	},
	
	/**
	 * If we are to combine this with an existing filter, this must be rewritten
	 * @param n
	 */
	setMaxCount( n ) {
		this.maxCount = n;
		this.setFilter( ( child, index ) => {
			return 0 === n || index < n;
		} );
	},
	
	onRender() {
		let self = this;
		if ( this.maxCount && this.collection.length > this.maxCount ) {
			let showMoreSnippet = new Snippet( {
				model      : new Bb.Model( {
					header: T.tc( 'CollectionView', 'Show %s more...' ).format( this.collection.length - this.maxCount )
				} ),
			} );
			this.listenToOnce( showMoreSnippet, 'open', () => {
				self.removeChildView(showMoreSnippet);
				self.setMaxCount( 0 );
			} );
			this.addChildView( showMoreSnippet );
		}
		
		this.listenTo(this.collection, 'update', ()=> {
			if ( this.maxCount && this.collection.length >= this.maxCount ) {
				this.render();
			}
	   });
	}
	
} );

export default CollectionView;
